<template>
  <div>
    <div
      :style="`z-index: 0;position: relative;height:fit-content;color#fff;padding:15px;padding-bottom:25px ;background:${$bgColor}`">
      <v-row>
        <strong style="font-size: 20px;padding:15px;" :style="{ 'color': $isTargetShop() ? '#000' : $colorSub2 }">{{
          $t("message.myPackage") }}</strong>
        <div style="align-items: center;display: flex;"> <img v-if="profile && profile.pictureUrl" style="
                  border-color: white;
                  height: 40px;" alt="Avatar" :src="$images.point" /></div>
      </v-row>
      <v-row justify="center" class="mt-3 pt-2">
        <v-col cols="4" align="center" class="pa-2"
          style="font-size:15px !important;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;">
          {{ $t("message.allPackage") }}
          <v-col align="center" class="pa-0"
            :style="'font-size:15px !important;color:' + ($isTargetShop() ? '#000;' : $bgColor + 'font-weight:bold;')"
            v-if="myPackage && myPackage.length > 0">{{ myPackage.length }}</v-col>
          <v-col align="center" class="pa-0"
            :style="'font-size:15px !important;color:' + ($isTargetShop() ? '#000' : $bgColor + 'font-weight: bold;')"
            v-if="myPackage && myPackage.length <= 0">0</v-col>
        </v-col>
        <v-col cols="4" align="center" class="pa-2"
          style="font-size:15px !important;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;">
          {{ $t("message.availablePackages") }}
          <v-col align="center"
            :style="'font-size:15px !important;color:' + ($isTargetShop() ? '#000' : $bgColor + 'font-weight: bold')"
            class="pa-0">{{ myPackage ? myPackage.filter(a => a.expirePackage * 1000 > today.getTime()).filter(a => a.balanceAmount > 0).length : 0 }}</v-col>
        </v-col>
      </v-row>
    </div>
    <div>
      <template style="padding-top:10px">
        <v-tabs v-model="tab" :background-color="levelById.color" :style="{ 'color': $colorSub2 === '#ffffff' ? '#000' : $colorSub2 }">
          <v-tabs-slider :color="$colorSub"></v-tabs-slider>
          <v-tab href="#tab-1" :style="{ 'color': $colorSub2 === '#ffffff' ? '#000' : $colorSub2 }"> {{ $t("message.myPackage") }}
          </v-tab>

          <v-tab href="#tab-2" :style="{ 'color': $colorSub2 === '#ffffff' ? '#000' : $colorSub2 }"> {{ $t("message.packageHistory")}} </v-tab>

          <v-tab href="#tab-3" :style="{ 'color': $colorSub2 === '#ffffff' ? '#000' : $colorSub2 }"> {{ $t("message.unusablePackage")}} </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab"
          style="background-color: #ffffff00 !important; min-height: 67vh;padding:13px;box-sizing: border-box;display: flex;flex-direction: column;">
          <v-tab-item :value="'tab-1'" v-if="myPackage">
            <div v-if="usablePackage.length < 1"
              style="height: 45vh;display: flex;align-items: center;justify-content: center;">
              <div style="justify-content: center; display: flex; flex-direction: column;">
                <v-icon>mdi-close-circle</v-icon>
                <p class="mb-0">{{ $t("message.dontPackage") }}</p>
              </div>
            </div>
            <v-card :elevation="$isTargetShop() ? 0 : 1" v-for="(item, i) in usablePackage" :key="i" class="mb-0 mt-5"
              height="auto" :flat="$isTargetShop()" :tile="$isTargetShop()"
              :style="$isTargetShop() ? 'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 0px;border: solid ' + '#ffffff00' : 'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $bgColor3">
              <v-row>
                <v-col cols="4" style="padding-top:10px;" align="center">
                  <img :src="item.packageImg"
                    style="width: 85px; height: 85px;border-radius: 25px;border-style: solid;border-color: #eeee;"
                    class="link" />
                </v-col>
                <v-col cols="5" class="pl-3 pr-0">
                  <div class="font16 bold mt-1">
                    <v-col class="pa-0">{{ item.packageName }}</v-col>
                    <v-col class="pl-0 pt-0 pb-1 font12 icon2" v-if="item.expirePackage !== '' && item.expirePackage">{{
                      $t("message.useBefor") }} {{ arrayMove(item.expirePackage) + ' น.' }}</v-col>
                    <v-col class="pl-0 pt-0 pb-1 font12 icon2" v-else-if="item.expirePackage !== ''">{{
                      $t("message.notHaveExpire") }}</v-col>
                  </div>
                </v-col>
                <v-col cols="3" class="pa-0">
                  <div class="font16 bold mt-0">
                    <v-col style="text-align: center;" class="font12 icon2 pb-0" v-if="item.balanceAmount">{{
                      $t("message.balance") }}</v-col>
                    <div style="display: flex;justify-content:center">
                      <div :style="'color:' + $bgColor + ';margin-bottom:0;font-size: 24px;font-weight: bold;'"
                        v-if="item.balanceAmount">
                        {{ showDecimal(item.balanceAmount) }}
                      </div>
                      <div style="margin-bottom:0;text-align: center;padding-top:9px" v-if="item.amount">
                        /{{ item.amount }}
                      </div>
                    </div>
                    <v-col class="pt-1 pl-0 pr-0" align="center" v-if="item.expirePackage !== '' && item.expirePackage">
                      <v-btn :tile="$isTargetShop()" :elevation="$isTargetShop() ? 0 : 2" v-if="
                        item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0 && (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'use'" x-small class="bold"
                        :style="'background-color:' + $bgColor + ';' + ($isTargetShop() ? 'color:#000' : 'color:white')" @click="useReward(item)">
                        {{ $t("message.usePackeage") }}</v-btn>
                      <v-btn v-else-if="item.balanceAmount <= 0" x-small class="bold"  :style="'background-color:' + $bgColor " >
                        {{ $t("message.outPackage") }}
                      </v-btn>
                      <v-btn v-else-if="item.expirePackage * 1000 < today.getTime()" x-small class="bold"  :style="'background-color:' + $bgColor ">
                        {{ $t("message.expireReward") }}
                      </v-btn>
                    </v-col>
                    <v-col class="pt-1 pl-0 pr-0" align="center" v-if="item.expirePackage === ''">
                      <v-btn  :text="$isTargetShop()" :tile="$isTargetShop()" :elevation="$isTargetShop() ? 0 : 2" v-if="
                        item.balanceAmount > 0 && (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'use'"  x-small class="bold"
                        :style="'background-color:' + $bgColor + ';' + ($isTargetShop() ? 'color:#000' : 'color:white')" @click="useReward(item)">{{
                          $t("message.usePackeage") }}</v-btn>
                      <v-btn v-if="item.balanceAmount <= 0" x-small class="bold" :style="'background-color:'+$bgColor">
                        {{ $t("message.outPackage") }}
                      </v-btn>
                    </v-col>
                  </div>
                </v-col>
                <v-col
                  v-if="item.useInBranch && item.useInBranch !== '' && item.useInBranch !== 'None' && item.useInBranch.length > 0">
                  <span class="d-flex"><v-icon class="mr-2" :color="$bgColor">mdi-store</v-icon>
                    <p class="mb-0" style="font-weight: bold">สาขาที่สามารถใช้แพ็กเกจได้</p>
                  </span>
                  <span v-for="(item2, i) in item.useInBranch" :key="i">
                    <v-chip class="mt-2 mr-2">{{ item2 }}</v-chip>
                  </span>
                </v-col>
                <div v-if="item.expirePackage !== '' && item.expirePackage">
                  <v-btn :text="$isTargetShop()" :tile="$isTargetShop()" :elevation="$isTargetShop() ? 0 : 2" v-if="
                    item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0 && (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'get'
                  " :color="$isTargetShop() ? $bgColor : '#4caf50'" small block class="bold" :disabled="true"
                    :style="$isTargetShop() ? 'color:#000' : 'color:white'">...{{ $t("message.waitStore") }}</v-btn>
                  <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                    item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0 && (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'get'
                  ">📌📌 {{ $t("message.storeNotice") }}</div>
                </div>
                <div v-if="item.expirePackage === ''">
                  <v-btn :text="$isTargetShop()" :tile="$isTargetShop()" :elevation="$isTargetShop() ? 0 : 2" v-if="
                    item.balanceAmount > 0 && (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'get'
                  " :color="$isTargetShop() ? $bgColor : '#4caf50'" small block class="bold" :disabled="true"
                    :style="$isTargetShop() ? 'color:#000' : 'color:white'">...{{ $t("message.waitStore") }}</v-btn>
                  <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                    item.balanceAmount > 0 && (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'get'
                  ">📌📌 {{ $t("message.storeNotice") }}</div>
                </div>
                <div v-if="item.expirePackage === null && shopId === 'SD_1737957295593'">
                  <v-btn :text="$isTargetShop()" :tile="$isTargetShop()" :elevation="$isTargetShop() ? 0 : 2" v-if="
                    (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'get'
                  " :color="$isTargetShop() ? $bgColor : '#4caf50'" small block class="bold" :disabled="true"
                    :style="$isTargetShop() ? 'color:#000' : 'color:white'">...{{ $t("message.waitStore") }}</v-btn>
                  <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                    (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'get'
                  ">📌📌 {{ $t("message.storeNotice") }}</div>
                  <v-btn v-if="
                    (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'use'
                  " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                    :elevation="$isTargetShop() ? 0 : 2" small block class="bold"
                    :style="$isTargetShop() ? 'color:#000' : 'color:white'">{{ $t("message.packageAlready") }}</v-btn>
                  <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                    (item.flowId === '' || item.flowId === null || item.flowId === 'None') && item.status === 'use'
                  ">📌📌 {{ $t("message.checkRewardForpackage") }} <span
                      style="text-decoration: underline;color: #3c6c9c;" @click="$router.push('/NewMyReward')">{{ $t("message.myReward") }}</span></div>
                </div>
              </v-row>
              <div class="mt-2" v-if="item.expirePackage !== '' && item.expirePackage">
                <v-btn v-if="
                  item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'use'
                " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                  :elevation="$isTargetShop() ? 0 : 2" small block class="bold"
                  :style="$isTargetShop() ? 'color:#000' : 'color:white'" @click="openDialogGetFlowId(item)">{{
                    $t("message.useAndappoint") }}</v-btn>
                <v-btn v-if="
                  item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'get'
                " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                  :elevation="$isTargetShop() ? 0 : 2" small block class="bold" :disabled="true"
                  :style="$isTargetShop() ? 'color:#000' : 'color:white'">...{{ $t("message.waitStore") }}</v-btn>
                <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                  item.expirePackage * 1000 > today.getTime() && item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'get'
                ">📌📌 {{ $t("message.storeNotice") }}</div>
              </div>
              <div class="mt-2" v-if="item.expirePackage === ''">
                <v-btn v-if="
                  item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'use'
                " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                  :elevation="$isTargetShop() ? 0 : 2" small block class="bold"
                  :style="$isTargetShop() ? 'color:#000' : 'color:white'" @click="openDialogGetFlowId(item)">{{
                    $t("message.useAndappoint") }}</v-btn>
                <v-btn v-if="
                  item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'get'
                " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                  :elevation="$isTargetShop() ? 0 : 2" small block class="bold" :disabled="true"
                  :style="$isTargetShop() ? 'color:#000' : 'color:white'">...{{ $t("message.waitStore") }}</v-btn>
                <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                  item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'get'
                ">📌📌 {{ $t("message.storeNotice") }}</div>
              </div>
              <div class="mt-2" v-if="item.expirePackage === null">
                <v-btn v-if="
                  item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'use'
                " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                  :elevation="$isTargetShop() ? 0 : 2" small block class="bold"
                  :style="$isTargetShop() ? 'color:#000' : 'color:white'" @click="openDialogGetFlowId(item)">{{
                    $t("message.useAndappoint") }}</v-btn>
                <v-btn v-if="
                  item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'get'
                " :color="$isTargetShop() ? $bgColor : '#4caf50'" :text="$isTargetShop()" :tile="$isTargetShop()"
                  :elevation="$isTargetShop() ? 0 : 2" small block class="bold" :disabled="true"
                  :style="$isTargetShop() ? 'color:#000' : 'color:white'">...{{ $t("message.waitStore") }}</v-btn>
                <div class="mt-2" style="background: #dddddd;font-size: 15px;padding: 12px;color: gray;" v-if="
                  item.balanceAmount > 0 && item.flowId !== '' && item.flowId !== null && item.flowId !== 'None' && item.status === 'get'
                ">📌📌 {{ $t("message.storeNotice") }}</div>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-2'" v-if="myPackage">
            <v-card flat>
              <v-card-text>
                <v-data-table class="mytable" :headers="columns2" :items="myPackageTransaxtion" :items-per-page="10"
                  dense>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_be(item.CREATE_DATE) }}
                  </template>
                </v-data-table></v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-3'" v-if="myPackage">
            <div v-if="unusablePackage.length < 1"
              style="height: 45vh;display: flex;align-items: center;justify-content: center;">
              <div style="justify-content: center; display: flex; flex-direction: column;">
                <v-icon>mdi-close-circle</v-icon>
                <p class="mb-0">{{ $t("message.dontUnusablePackage") }}</p>
              </div>
            </div>
            <v-card :elevation="$isTargetShop() ? 0 : 1" v-for="(item, i) in unusablePackage" :key="i" class="mb-0 mt-5"
              height="auto" :flat="$isTargetShop()" :tile="$isTargetShop()"
              :style="$isTargetShop() ? 'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 0px;border: solid ' + '#ffffff00' : 'box-shadow: 0px 4px 4px 0px #00000040;padding:15px;border-radius: 20px;border: solid ' + $bgColor3">
              <v-row>
                <v-col cols="4" style="padding-top:10px;" align="center">
                  <img :src="item.packageImg"
                    style="width: 85px; height: 85px;border-radius: 25px;border-style: solid;border-color: #eeee;opacity: 0.6;"
                    class="link" />
                </v-col>
                <v-col cols="5" class="pl-3 pr-0">
                  <div class="font16 bold mt-1">
                    <v-col class="pa-0">{{ item.packageName }}</v-col>
                    <v-col class="pl-0 pt-0 pb-1 font12 icon2" v-if="item.expirePackage !== '' && item.expirePackage">{{
                      $t("message.useBefor") }} {{ arrayMove(item.expirePackage) + ' น.' }}</v-col>
                    <v-col class="pl-0 pt-0 pb-1 font12 icon2" v-else>{{ $t("message.notHaveExpire") }}</v-col>
                  </div>
                </v-col>
                <v-col cols="3" class="pa-0">
                  <div class="font16 bold mt-0">
                    <v-col style="text-align: center;" class="font12 icon2 pb-0" v-if="item.balanceAmount">{{
                      $t("message.balance") }}</v-col>
                    <div style="display: flex;justify-content:center">
                      <div style="color:#9e9e9e;margin-bottom:0;font-size: 24px;font-weight: bold;"
                        v-if="item.balanceAmount">
                        {{ showDecimal(item.balanceAmount) }}
                      </div>
                      <div style="margin-bottom:0;text-align: center;padding-top:9px" v-if="item.amount">
                        /{{ item.amount }}
                      </div>
                    </div>
                    <v-col class="pt-1 pl-0 pr-0" align="center">
                      <v-btn x-small class="bold" disabled>{{ isExpired(item) ? $t("message.expireReward") : $t("message.outPackage") }}</v-btn>
                    </v-col>
                  </div>
                </v-col>
                <v-col
                  v-if="item.useInBranch && item.useInBranch !== '' && item.useInBranch !== 'None' && item.useInBranch.length > 0">
                  <span class="d-flex"><v-icon class="mr-2" :color="$bgColor">mdi-store</v-icon>
                    <p class="mb-0" style="font-weight: bold">สาขาที่สามารถใช้แพ็กเกจได้</p>
                  </span>
                  <span v-for="(item2, i) in item.useInBranch" :key="i">
                    <v-chip class="mt-2 mr-2">{{ item2 }}</v-chip>
                  </span>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </div>

    <v-dialog class="no-radius" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="no-radius" v-if="dialog && use">
        <v-toolbar dark :color="levelById.color" :tile="$isTargetShop()" :flat="$isTargetShop()"
          :style="'background-color:' + levelById.color + ';border-radius: 0px !important;'">
          <v-btn icon dark @click="closeUseReward, handler()" :style="$isTargetShop() ? 'color:#000' : ''">
            <v-icon  :style="'color:' + ( HEXToVBColorLMG(levelById.color) )">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :style="'color:' + ( HEXToVBColorLMG(levelById.color) )">Use Package</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-list subheader>
          <v-subheader>{{ $t("message.showQrcodeReward") }}</v-subheader>
          <!-- <v-divider></v-divider> -->
        </v-list>

        <div>
          <div class="text-center">
            <qrcode-usecode :shopIdProp="use.shopId" :token="use.token" :memberId="profile.memberId" :tpk="tpk"
              ref="dialog"></qrcode-usecode>
          </div>
        </div>
        <v-divider></v-divider>
        <div>
          <div class="text-center headline1 font20">
            {{ $t("message.detailPackage") }}
          </div>
        </div>
        <v-divider></v-divider>
        <div>
          <div style="text-align: center;" class="font16 bold headline1">{{ use.packageName }}</div>
          <div class="d-flex flex-column justify-space-between align-center"><v-img :src="use.packageImg"
              max-width="150"></v-img></div>
        </div>
        <div>
          <div class="text-center">
            <div class="font16 bold headline1">
              <div>{{ use.name }}</div>
            </div>
            <div class="font14 icon2">
              <div class="pl-0 pt-0 pb-3">{{ $t("message.useBefor") }}
                <span class="icon1">{{ new Date(use.expirePackage * 1000).toLocaleString() }}</span>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog class="no-radius" v-model="dialogBelink" fullscreen hide-overlay transition="dialog-bottom-transition"
      >
      <v-card class="no-radius">
        <v-toolbar dark :color="$bgColor"
          :style="$isTargetShop() ? 'height:50px;background-color:' + $bgColor : ';height:50px;width:100%;border-radius: 0px;background-image: linear-gradient(179deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
          <v-btn icon dark @click="dialogBelink = false, step === 0, selectedService = []">
            <v-icon :style="'color:' + ( HEXToVBColorLMG(levelById.color) )">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :style="'color:' + ( HEXToVBColorLMG(levelById.color) )">{{ $t("message.servicesAvailable") }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-subheader>{{ $t("message.plsSelectService") }}</v-subheader>
        <v-list three-line subheader
          style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <v-card v-for="(item, i) in selectedService" :key="i" class="ml-4 mr-4 mb-5 mt-4"
            style="border-radius: 20px; height: 50px; display: flex; align-items: center;" width="93%" elevation="3">
            <div style="display: flex; align-items: center; width: 100%;" class="ml-3 mr-3">
              <div class="font16 bold headline1" style="margin-right: auto;">{{ item.text }}</div>
              <v-btn small :style="'background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'"
                dark @click="step1(item)">{{ $t("message.usePackage") }}
              </v-btn>
            </div>
          </v-card>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-if="step === 1"  class="no-radius" v-model="dialogStep1" fullscreen hide-overlay transition="dialog-left-transition"
      style="border-radius: 10 ! important">
      <v-card class="no-radius">
        <step1 :closeService=step0 :selectedBranch=handleSelectedBranch :choosePackage=choosePackage
          :selectedService=serviceName />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Qrcode from './Qrcode.vue'
import axios from 'axios'
import moment from 'moment'
import SelectedPackage from './SelectedPackage.vue'
export default {
  name: 'AllRewards',
  components: {
    'qrcode-usecode': Qrcode,
    'step1': SelectedPackage
  },
  data () {
    return {
      myShopId: this.$session.getAll().shopId,
      serviceName: '',
      choosePackage: '',
      dataPushToBeLink: {},
      selectedFlowId: null,
      selectedBranchID: null,
      selectedService: [],
      namePackage: [],
      itemLinked: [],
      selectedFlowIds: '',
      step: 0,
      dialogStep1: false,
      myPackage: null,
      myPackageTransaxtion: null,
      member: null,
      profile: null,
      use: null,
      dialog: false,
      dialogBelink: false,
      tpk: null, // timestamp package
      liffID: null,
      today: new Date(),
      tab: null,
      shopId: null,
      dataLineConfig: [],
      liff: 'https://liff.line.me/',
      typeBelinked: null,
      selected: '',
      mapDataBranch: {},
      branchLoyalty: [],
      levelById: null,
      columns2: [
        { text: 'ชื่อแพ็กเกจ', value: 'packageName' },
        { text: 'จำนวน', value: 'balanceAmount' },
        // { text: 'สาขา', value: 'balanceAmount' },
        { text: 'คะแนนที่ได้', value: 'packagePoint' },
        { text: 'เวลาที่ใช้', value: 'CREATE_DATE' }
      ]
    }
  },
  computed: {
    usablePackage () {
      return this.myPackage ? this.myPackage.filter((item) => !this.isExpired(item) && !this.isOutOfBalance(item)) : []
    },
    unusablePackage () {
      return this.myPackage ? this.myPackage.filter((item) => this.isExpired(item) || this.isOutOfBalance(item)) : []
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.itemLinked = []
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getBranch()
    await this.getPackage()
    await this.getPackageTransaction()
    await this.getFlowLinked()
    await this.getLevelById()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    async getLevelById () {
      if (!this.member || !this.member.levelId) {
        return null
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )

      if (result) {
        this.levelById = result
        return result
      }
    },
    async getBranch () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
          '/master_branch/get?shopId=' +
          this.shopId
        )
        .then(async (response) => {
          if (response.data.status !== false) {
            this.branchLoyalty = response.data
            this.branchLoyalty = this.branchLoyalty.forEach((item) => {
              this.mapDataBranch[item.masBranchID] = item.masBranchName
            })
            // this.detailPromotion.forEach((item) => {
            //   if (item.useInBranch && item.useInBranch !== '') {
            //     item.useInBranch = JSON.parse(item.useInBranch)
            //   }
            // })
          }
        })
        .catch((error) => {
          console.error('error function getBranchBelink : ', error)
          this.Branch = []
        })
    },
    async handler () {
      try {
        await this.getPackage()
        this.dialog = false
        if (this.$refs.dialog && typeof this.$refs.dialog.test === 'function') {
          this.$refs.dialog.test()
        }
      } catch (error) {
        console.error(error)
      }
    },
    isExpired (item) {
      if (item.expirePackage === '' || item.expirePackage === null || item.expirePackage === undefined) {
        return false
      }
      return item.expirePackage * 1000 < this.today.getTime()
    },
    isOutOfBalance (item) {
      return !(Number(item.balanceAmount) > 0)
    },
    showDecimal (item) {
      if (item.split('.')[1] === '0') {
        return item.split('.')[0]
      } else {
        return item
      }
    },
    arrayMove (arr, oldindex, newindex) {
      // arr.splice(newindex, 0, arr.splice(oldindex, 1)[0])
      return moment.unix(arr).add(543, 'years').format('DD/MM/YYYY HH:mm')
    },
    format_date_be (value) {
      if (!value) {
        return ''
      }
      return moment.utc(String(value)).add(543, 'years').format('DD/MM/YYYY HH:mm')
    },
    async getPackage () {
      try {
        const result = await this.callBeTaskAPI(
          'get',
          `/PackageLog/getBystatus?memberId=${this.profile.memberId}&shopId=${this.shopId}`
        )
        if (Array.isArray(result)) {
          this.myPackage = result
          this.myPackage.map((item) => {
            if (item.useInBranch && item.useInBranch !== '' && item.useInBranch !== 'None' && item.useInBranch !== null) {
              if (typeof item.useInBranch === 'string') {
                item.useInBranch = JSON.parse(item.useInBranch)
                if (item.useInBranch.length > 0) {
                  item.useInBranch.forEach((item2, index) => {
                    item.useInBranch[index] = this.mapDataBranch[item2]
                  })
                } else {
                  item.useInBranch = null
                }
              }
            }
          })
        } else {
          this.myPackage = []
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async getPackageTransaction () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageTransaction/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackageTransaxtion = result
      }
      // console.log(new Date(this.momenDate_1(result[0].endDate)).getTime())
    },
    useReward (item) {
      try {
        this.use = item
        this.dialog = true
        const timestamp = Date.now()
        const timestampPlus3Minutes = moment(timestamp).add(3, 'minutes').valueOf()
        this.tpk = Buffer.from(timestampPlus3Minutes.toString()).toString('base64')

        // console.log('timestamp', timestamp)
        // console.log('Encode timestamp', encodedTimestamp)
        // const decodedBuffer = Buffer.from(this.tpk, 'base64')

        // const decodedString = decodedBuffer.toString('utf-8')

        // const timestampDecode = parseInt(decodedString)
      } catch (error) {
        console.error('error', error)
      }
      // print('endcode timestamp:', timestamp)
    },
    closeUseReward () {
      this.myPackage = null
      this.getPackage()
      this.dialog = false
    },
    checkEqualService (item) {
      this.selectedFlowIds = item.flowId.split(',')
      this.dataPushToBeLink = item
      this.selectedFlowIds.map(flowId => {
        const linkedItem = this.itemLinked.find(item => item.value.toString() === flowId)
        if (linkedItem) {
          this.selectedService.push(linkedItem)
          return linkedItem.text
        } else {
          return null
        }
      })
    },
    openDialogGetFlowId (item) {
      this.choosePackage = item
      this.step = 0
      this.dialogBelink = true
      this.checkEqualService(item)
    },
    async pushToBelinked (item) {
      await this.checkEqualService(item)
      item.flowId = this.selectedFlowId
      item.branchId = this.selectedBranchID
      await this.checktypeBelink()
      if (process.env.NODE_ENV === 'development') {
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
          window.location.href = 'https://liff.line.me/' + this.liffID + `/CalendarBookingEmp/?shopId=` + this.shopId + '&flowId=' + item.flowId + '&packageId=' + item.packageId + '&branchId=' + item.branchId + '&tokenPackage=' + item.token + '&packageName=' + item.packageName + '&source=loyalty'
        } else {
          window.location.href = 'https://liff.line.me/' + this.liffID + `?shopId=` + this.shopId + '&flowId=' + item.flowId + '&packageId=' + item.packageId + '&branchId=' + item.branchId + '&tokenPackage=' + item.token + '&packageName=' + item.packageName + '&source=loyalty'
        }
      } else {
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
          window.location.href = 'https://liff.line.me/' + this.liffID + `/CalendarBookingEmp/?shopId=` + this.shopId + '&flowId=' + item.flowId + '&packageId=' + item.packageId + '&branchId=' + item.branchId + '&tokenPackage=' + item.token + '&packageName=' + item.packageName + '&source=loyalty'
        } else {
          window.location.href = 'https://liff.line.me/' + this.liffID + `?shopId=` + this.shopId + '&flowId=' + item.flowId + '&packageId=' + item.packageId + '&branchId=' + item.branchId + '&tokenPackage=' + item.token + '&packageName=' + item.packageName + '&source=loyalty'
        }
      }
    },
    async checktypeBelink () {
      try {
        await this.getDataLineConfig(this.shopId)
        const result = await axios.get(this.DNS_Link + `/sys_shop/get?shopId=${this.shopId}`)
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
          if (result.data[0].timeSlotStatus === 'True') {
            // this.typeBelinked = '/BookingFormEmp'
            this.liffID = this.dataLineConfig.liffMainID
          } else {
            // this.typeBelinked = '/BookingForm'
            this.liffID = this.dataLineConfig.liffMainID
          }
        } else {
          if (result.data[0].timeSlotStatus === 'True') {
            this.typeBelinked = '/BookingFormEmp'
            this.liffID = this.dataLineConfig.liffBookingFormEmpID
          } else {
            this.typeBelinked = '/BookingForm'
            this.liffID = this.dataLineConfig.liffBookingFormID
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getDataLineConfig (shopId) {
      this.dataLineConfig = []
      await axios.get(this.DNS_Link + '/lineconfig/get?shopId=' + shopId).then(response => {
        let rs = response.data
        if (rs.status === false) {
          this.dataLineConfig = {
            liffMainID: '1656581804-7KRQyqo5',
            liffBookingFormID: '1656581804-32mk7OgE',
            liffBookingFormEmpID: '1656581804-b09WBwkP',
            checkConfig: false
          }
        } else {
          this.dataLineConfig = rs[0]
        }
      }).catch((error) => {
        console.error(error)
        this.dataLineConfig = {
          liffMainID: '1656581804-7KRQyqo5',
          liffBookingFormID: '1656581804-32mk7OgE',
          liffBookingFormEmpID: '1656581804-b09WBwkP',
          checkConfig: false
        }
      })
    },
    handleSelectedBranch (branchID) {
      this.selectedBranchID = branchID
      this.pushToBelinked(this.dataPushToBeLink)
    },
    step1 (item) {
      this.dialogStep1 = true
      this.step = 1
      this.selectedFlowId = item.value
      this.serviceName = item.text
    },
    step0 () {
      this.dialogStep1 = false
      this.step = 0
    },
    getFlowLinked () {
      axios
        .get(
          'https://api-belinked.betaskthai.tech/flow/get?shopId=' + this.shopId
        )
        .then(response => {
          let rs = response.data
          if (Array.isArray(rs)) {
            rs.forEach(el => this.itemLinked.push({ value: el.flowId, text: el.flowName }))
          } else {
            console.warn('getFlowLinked: unexpected response', rs)
          }
        })
    }
  }
}
</script>
<style scoped>
a.v-tab {
  text-decoration: none;
}
.v-dialog.no-radius .v-card,
.v-dialog.no-radius .v-toolbar,
.v-dialog.no-radius .v-card__title {
  border-radius: 0 !important;
}
::v-deep .v-dialog {
  border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Package/MyPackage.vue